import { render } from "./GetSprites.vue?vue&type=template&id=b4018100"
import script from "./GetSprites.vue?vue&type=script&lang=ts"
export * from "./GetSprites.vue?vue&type=script&lang=ts"

import "./GetSprites.vue?vue&type=style&index=0&id=b4018100&lang=css"
script.render = render

export default script